const SEARCH_QUERIES_KEY = "SEARCH_QUERIES"

export function saveSearchQueries(queries) {
    localStorage.setItem(SEARCH_QUERIES_KEY, JSON.stringify(queries))
}

export function loadSearchQueries() {
    return JSON.parse(localStorage.getItem(SEARCH_QUERIES_KEY))
}
